import React, { useState } from 'react';
import { X, Upload, Sparkles, Link as LinkIcon, Image as ImageIcon } from 'lucide-react';
import { generateImageWithGemini } from '../../../../services/aiService';
import { menuService } from '../../../../services/menuService';
import { useAlert } from '../../../../context/AlertContext';

const MediaModal = ({ isOpen, onClose, onApply, effectiveTenantId, tenantData }) => {
    const [mediaUrl, setMediaUrl] = useState('');
    const [mediaUploading, setMediaUploading] = useState(false);
    const [aiImagePrompt, setAiImagePrompt] = useState('');
    const [isGeneratingImage, setIsGeneratingImage] = useState(false);
    const [generatedPreviewUrl, setGeneratedPreviewUrl] = useState('');
    const [error, setError] = useState('');
    const { showAlert } = useAlert();

    if (!isOpen) return null;

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setMediaUploading(true);
        try {
            const url = await menuService.uploadFile(effectiveTenantId, file);
            onApply(url);
        } catch (err) {
            showAlert("Görsel yüklenirken bir hata oluştu.", "error");
        } finally {
            setMediaUploading(false);
        }
    };

    const handleGenerateAIImage = async () => {
        if (tenantData?.plan !== 'premium') {
            showAlert("AI Görsel Oluşturucu sadece Premium plan kullanıcıları içindir.", "warning");
            return;
        }
        if (!aiImagePrompt.trim()) return;

        setIsGeneratingImage(true);
        setError('');
        try {
            const imageUrl = await generateImageWithGemini(aiImagePrompt);
            setGeneratedPreviewUrl(imageUrl);
        } catch (err) {
            setError("Görsel oluşturulurken bir hata oluştu: " + err.message);
        } finally {
            setIsGeneratingImage(false);
        }
    };

    const handleApplyAIOrUrl = async (url) => {
        if (!url) return;
        let finalUrl = url;

        if (url.startsWith('data:')) {
            setMediaUploading(true);
            try {
                finalUrl = await menuService.uploadBase64(effectiveTenantId, url);
            } catch (err) {
                showAlert(err.message, 'error');
                setMediaUploading(false);
                return;
            }
        }
        setMediaUploading(false);
        onApply(finalUrl);
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }} onClick={onClose}>
            <div className="card glass custom-scrollbar" onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: '500px', background: 'var(--bg-card)', borderRadius: '24px', overflow: 'hidden' }}>
                <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ fontSize: '1.25rem', fontWeight: 800 }}>Görsel Seç</h3>
                    <button onClick={onClose} style={{
                        background: 'rgba(0,0,0,0.05)',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '10px',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'var(--text-main)',
                        transition: 'all 0.2s',
                        outline: 'none'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = 'rgba(239, 68, 68, 0.1)'}
                    onMouseOut={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.05)'}
                    >
                        <X size={20} strokeWidth={2.5} />
                    </button>
                </div>

                <div style={{ padding: '2rem', maxHeight: '70vh', overflowY: 'auto' }}>
                    {error && <div style={{ padding: '1rem', background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', borderRadius: '12px', marginBottom: '1rem' }}>{error}</div>}

                    {/* Dosya Yükleme */}
                    <label style={{ border: '2px dashed var(--border)', borderRadius: '16px', padding: '3rem 2rem', textAlign: 'center', cursor: 'pointer', display: 'block', transition: 'all 0.2s' }}>
                        <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileUpload} disabled={mediaUploading} />
                        {mediaUploading ? (
                            <div className="animate-spin" style={{ width: '32px', height: '32px', margin: '0 auto', border: '3px solid var(--primary)', borderTopColor: 'transparent', borderRadius: '50%' }}></div>
                        ) : (
                            <>
                                <Upload size={32} style={{ marginBottom: '1rem', color: 'var(--primary)' }} />
                                <div style={{ fontWeight: 700 }}>Dosya Yükle</div>
                                <div style={{ fontSize: '0.8125rem', color: 'var(--text-muted)', marginTop: '0.5rem' }}>Cihazınızdan bir görsel seçin</div>
                            </>
                        )}
                    </label>

                    <div style={{ margin: '2rem 0', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ flex: 1, height: '1px', background: 'var(--border)' }}></div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontWeight: 700 }}>AI SİHİRBAZI</div>
                        <div style={{ flex: 1, height: '1px', background: 'var(--border)' }}></div>
                    </div>

                    {/* AI Sihirbazı */}
                    <div style={{ padding: '1.5rem', background: 'rgba(var(--primary-rgb), 0.05)', borderRadius: '16px', border: '1px dashed var(--primary)' }}>
                        <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: 700, fontSize: '0.875rem', color: 'var(--primary)' }}>AI ile Görsel Oluştur</label>
                        <div style={{ display: 'flex', gap: '0.75rem' }}>
                            <input
                                placeholder="Örn: Çikolatalı sufle..." value={aiImagePrompt}
                                onChange={e => setAiImagePrompt(e.target.value)}
                                style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--bg-card)' }}
                                onKeyPress={e => e.key === 'Enter' && handleGenerateAIImage()}
                            />
                            <button onClick={handleGenerateAIImage} disabled={isGeneratingImage || !aiImagePrompt} className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '0 16px', borderRadius: '10px' }}>
                                {isGeneratingImage ? <div className="animate-spin" style={{ width: '16px', height: '16px', border: '2px solid white', borderTopColor: 'transparent', borderRadius: '50%' }}></div> : <Sparkles size={16} />}
                            </button>
                        </div>
                        {generatedPreviewUrl && (
                            <div style={{ marginTop: '1rem' }}>
                                <img src={generatedPreviewUrl} alt="AI Generated" style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '12px', marginBottom: '1rem' }} />
                                <button onClick={() => handleApplyAIOrUrl(generatedPreviewUrl)} disabled={mediaUploading} style={{ width: '100%', padding: '12px', background: '#22c55e', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 700, cursor: 'pointer' }}>
                                    Bu Görseli Kullan
                                </button>
                            </div>
                        )}
                    </div>

                    <div style={{ margin: '2rem 0', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ flex: 1, height: '1px', background: 'var(--border)' }}></div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', fontWeight: 700 }}>VEYA</div>
                        <div style={{ flex: 1, height: '1px', background: 'var(--border)' }}></div>
                    </div>

                    {/* URL Ekleme */}
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: 700, fontSize: '0.875rem' }}>URL ile Ekle</label>
                        <div style={{ display: 'flex', gap: '0.75rem' }}>
                            <div style={{ flex: 1, position: 'relative' }}>
                                <LinkIcon size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                                <input
                                    style={{ paddingLeft: '40px', width: '100%', padding: '10px', borderRadius: '10px', border: '1px solid var(--border)', background: 'var(--bg-card)' }}
                                    placeholder="Görsel bağlantısını yapıştırın..." value={mediaUrl} onChange={e => setMediaUrl(e.target.value)}
                                />
                            </div>
                            <button onClick={() => handleApplyAIOrUrl(mediaUrl)} className="btn-primary" style={{ padding: '0 1.5rem', borderRadius: '10px' }}>Uygula</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MediaModal;